import { render, staticRenderFns } from "./submitSpcOrder.vue?vue&type=template&id=f3dab03c&scoped=true"
import script from "./submitSpcOrder.vue?vue&type=script&lang=js"
export * from "./submitSpcOrder.vue?vue&type=script&lang=js"
import style0 from "./submitSpcOrder.vue?vue&type=style&index=0&id=f3dab03c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f3dab03c",
  null
  
)

export default component.exports